import { SelectProps } from 'antd';
import { ValidateStatus } from 'antd/es/form/FormItem';

import { ArrayElement, Enum, FormFieldsErrors, QueryError } from '@/common/interfaces';

export const defineInputStatus = (isFormLoading: boolean, error?: boolean | string | number): ValidateStatus | undefined => {
  if (isFormLoading) return 'validating';
  if (error) return 'error';
  return undefined;
};

export const extractFormErrors = <Inputs extends Enum<Inputs>>(error: QueryError): FormFieldsErrors<Inputs> => {
  const errorMessage = error.response?.data.message;
  const inputsErrors: Record<string, string> = {};

  if (errorMessage && Array.isArray(errorMessage) && errorMessage[0]?.field) {
    inputsErrors[errorMessage[0].field] = errorMessage[0].errors[0];
  }

  return Object.keys(inputsErrors).length ? inputsErrors : null;
};

export const parseSelectData = <T extends Record<string, unknown>, L extends keyof T, V extends keyof T>(
  data: T[] | undefined,
  props: {
    label: L;
    value: V;
    disabled?: (opts: T) => boolean;
  } & Omit<ArrayElement<NonNullable<SelectProps['options']>>, 'label' | 'value' | 'disabled'>
): SelectProps['options'] => {
  const { value, label, disabled } = props;

  return Array.isArray(data)
    ? data.map((item) => {
      const { [label]: labelValue } = item;

      return {
        label: String(labelValue),
        value: String(item[value]),
        disabled: disabled ? disabled(item) : false,
        item
      };
    })
    : [];
};
